<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    :label="label"
    itemName="name"
    :items="items"
    :management-office="managementOffice"
    :operation-offices="operationOffices"
    :error-messages="errorMessages"
    :readonly="props.readonly"
    :isCombobox="true"
    :mapToObject="(v) => ({ name:v })"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from "@/types/responses/getManagementOffice";
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n'

const props = withDefaults(
  defineProps<{
    modelValue: getAccountResponse | undefined;
    managementOffice?: getManagementOffice | undefined;
    operationOffices?: getOperationOffice | undefined;
    errorMessages?: string[];
    readonly?: boolean
  }>(),
  {}
);

const emit = defineEmits(['update:modelValue']);
const label = i18n.global.t('pages.accounts.accountName');
const items = ref<getAccountResponse[]>([]);

onMounted(() => {
  Api().autoCompleteAccounts(undefined).then((data) => {
    items.value = data;
  });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
